import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import { HeaderGoBack } from '../header-go-back'

import s from './styles.module.scss'

export type HeaderVariant = 'white' | 'grey' | 'transparent'

interface Props {
  title?: string
  isCanDisable?: boolean
  onBack?: () => void
  onReset?: () => void
  isIconBlack?: boolean
  resetTitle?: string
  variant?: HeaderVariant
}

export const HeaderResetButton: FC<Props> = ({
  title,
  isCanDisable,
  onBack,
  onReset,
  resetTitle = 'reset',
  variant = 'white',
}) => {
  const { t } = useTranslation()

  return (
    <HeaderGoBack
      buttonWhite
      variant={variant}
      title={title}
      onGoBack={onBack}
      actionRight={
        <p
          style={{ fontSize: '14px', fontWeight: 600 }}
          className={clsx(s.textReset, isCanDisable && s.buttonReset)}
          onClick={() => {
            if (isCanDisable) {
              onReset?.()
            }
          }}
        >
          {t(resetTitle)}
        </p>
      }
    />
  )
}
